import { render, staticRenderFns } from "./popupWibo.vue?vue&type=template&id=57c5afb4&lang=pug&"
import script from "./popupWibo.vue?vue&type=script&lang=js&"
export * from "./popupWibo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports